import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Grid,
  Divider,
  Autocomplete,
  InputLabel,
  IconButton,
  FormControlLabel,
  Switch,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Snackbar, Alert } from "@mui/material";
import { countries } from "../../constants/countrylist";
import {
  createNewPortfolioUser,
  PortfolioAssignDelegate,
  PortfolioCreateAnnouncement,
  PortfolioListAnnouncement,
  PortfolioDeleteAnnouncement,
  PortfolioUpdateAnnouncement,
} from "../../util/API/portfolio";
import { commonRunQuery } from "../../util/API/loans";
import CustomAlert from "../../components/UI/CustomAlert/CustomAlert";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CampaignIcon from "@mui/icons-material/Campaign";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import AdminAnnouncements from "./AdminAnnouncements";

const BANK_ACCOUNT_TYPES = [
  { value: "checking", label: "Checking" },
  { value: "savings", label: "Savings" },
  { value: "business", label: "Business" },
];

const emptyBankDetails = {
  accountHolderName: "",
  bankName: "",
  accountNumber: "",
  confirmAccountNumber: "",
  routingNumber: "",
  swiftCode: "",
  accountType: "",
  bankCountry: "",
};

const AdminConsole = ({ onExit, userRole }) => {
  const [onboardData, setOnboardData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contactNumber: "",
    areaCode: "",
    countryCode: "",
    gender: "",
    role: "", // Default to investor
    assignedInvestorId: "", // To store the selected investor for a delegate
    hasEntities: false,
    entities: [""],
    // Add banking states here
    hasBankingInfo: false,
    bankName: "",
    accountNumber: "",
    currency: "",
    hasBankDetails: false,
    bankDetails: { ...emptyBankDetails },
  });
  const [isLoadingInvestors, setIsLoadingInvestors] = useState(false);
  const [isLoadingFunds, setIsLoadingFunds] = useState(false);
  const [isLoadingAnnouncements, setIsLoadingAnnouncements] = useState(false);
  const [isPublishingAnnouncement, setIsPublishingAnnouncement] =
    useState(false);
  const [deletingAnnouncementId, setDeletingAnnouncementId] = useState(null);
  const [showAccountNumber, setShowAccountNumber] = useState(false);
  const [bankFormErrors, setBankFormErrors] = useState({});

  const [investors, setInvestors] = useState([]);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });
  const [alert, setAlert] = useState({
    showAlert: false,
    message: "",
    severity: "",
    header: "",
    onConfirm: null,
    alertType: "",
  });
  const [adminTab, setAdminTab] = useState(0); // 0 = Onboard User, 1 = Announcements
  const [isOnboarding, setIsOnboarding] = useState(false);

  const [funds, setFunds] = useState([]);

  const [announcements, setAnnouncements] = useState([]);

  const [announcementForm, setAnnouncementForm] = useState({
    title: "",
    body: "",
    audienceType: "all",
    targetFundId: "",
    expiryDate: "",
    status: true, // true = active, false = inactive
  });
  const [editAnnouncementDialog, setEditAnnouncementDialog] = useState(false);
  const [editAnnouncementForm, setEditAnnouncementForm] = useState({
    id: "",
    title: "",
    body: "",
    audienceType: "all",
    targetFundId: "",
    expiryDate: "",
    status: true,
    numberby: 0
  });
  const [isUpdatingAnnouncement, setIsUpdatingAnnouncement] = useState(false);
  const [draggedItemIndex, setDraggedItemIndex] = useState(null);
  let agentID = localStorage.getItem("authUser");

  // Fetch investors on component mount
  useEffect(() => {
    fetchInvestors();
    fetchFunds();
    fetchAnnouncements();
  }, []);

  useEffect(() => {
    if (userRole !== "admin") {
      console.log("Not Admin-----------");
      const currentUserId =
        JSON.parse(sessionStorage.getItem("user"))?.userid || "";
      setOnboardData((prev) => ({
        ...prev,
        role: "delegate",
        assignedInvestorId: currentUserId,
      }));
    } else {
      console.log("Admin-----------");
      setOnboardData((prev) => ({ ...prev, role: "investor" }));
    }
  }, [userRole]);

  const fetchInvestors = async () => {
    setIsLoadingInvestors(true);
    try {
      const response = await commonRunQuery(364, "");
      const records = response?.data?.body?.record;
      if (records) {
        // Ensure we handle both single object and array responses
        const formattedInvestors = Array.isArray(records) ? records : [records];
        const mapped = formattedInvestors.map((item) => {
          const u = item.u;
          const ue = item.ue;
          const record = item.record;
          const first = u.firstName?.trim();
          const last = u.lastName?.trim();

          return {
            id: u.investor_id,
            // name: `${u.firstName} ${u.lastName}`,
            name: `${first || ""} ${last || ""}`.trim() || u.otherNames,
            email: ue.email,
            totalInvested: `$${Number(record.total_invested_amount).toLocaleString("en-US", { minimumFractionDigits: 2 })}`,
            activeFunds: record.total_unique_funds,
            status: "Active",
          };
        });
        console.log("mapped=======", mapped);
        setInvestors(mapped);
      }
    } catch (error) {
      console.error("Failed to fetch investors:", error);
    } finally {
      setIsLoadingInvestors(false);
    }
  };
  const fetchFunds = async () => {
    setIsLoadingFunds(true);
    try {
      const response = await commonRunQuery(359, "");
      const records = response?.data?.body?.record;
      if (records) {
        const recordsArray = Array.isArray(records) ? records : [records];
        const mapped = recordsArray.map((item) => ({
          id: item.funds.id,
          name: item.funds.name,
        }));
        setFunds(mapped);
      }
    } catch (error) {
      console.error("Failed to fetch funds:", error);
    } finally {
      setIsLoadingFunds(false);
    }
  };
  const fetchAnnouncements = async () => {
    setIsLoadingAnnouncements(true);
    try {
      const now = new Date();
      const formattedDate = `${now.getFullYear()}-` + `${String(now.getMonth() + 1).padStart(2, "0")}-` + `${String(now.getDate()).padStart(2, "0")}` + `${String(now.getHours()).padStart(2, "0")}:` + `${String(now.getMinutes()).padStart(2, "0")}:` + `${String(now.getSeconds()).padStart(2, "0")}`;
      
      const response = await PortfolioListAnnouncement(
        "",
        "0",
        "",
        "",
        "",
        "0",
        "",
        "1",
      );
      const records = response?.data?.body?.record;
      if (records) {
        const recordsArray = Array.isArray(records) ? records : [records];
        console.log("fetchAnnouncements_recordsArray-----------",recordsArray);
        const mapped = recordsArray
          .map((item) => {
            const a = item.Announcements;
            if (!a) return null;
            const fundId = a.fund_id;
            const isAllInvestors = !fundId || fundId === "0" || fundId === 0;
            const targetFundName = isAllInvestors
              ? "All Investors"
              : funds.find((f) => String(f.id) === String(fundId))?.name || `Fund ID: ${fundId}`;

              return {
                id: a.id,
                title: a.title,
                body: a.content,
                audienceType: isAllInvestors ? "all" : "fund",
                targetFundId: fundId,
                targetFundName,
                expiryDate: a.expirydate || "", // Capture expiry date if available
                status: a.status === "inactive" || a.status === 0 ? false : true, // Set default switch status boolean
                numberby: a.numberby
              };
          })
          .filter(Boolean)
          .sort((x, y) => Number(y.id) - Number(x.id));

        setAnnouncements(mapped);
      }
    } catch (error) {
      console.error("Failed to fetch announcements:", error);
    } finally {
      setIsLoadingAnnouncements(false);
    }
  };
  const handleInputChange = (e) => {
    console.log("e========", e);
    const { name, value } = e.target;
    console.log("name========", name);
    console.log("value========", value);
    setOnboardData((prev) => ({ ...prev, [name]: value }));
  };

  const clearFields = () => {
    setOnboardData({
      firstName: "",
      lastName: "",
      email: "",
      contactNumber: "",
      areaCode: "",
      countryCode: "",
      gender: "",
      role: userRole === "admin" ? "investor" : "delegate",
      assignedInvestorId: "",
      entities: [""],
      // Reset banking states
      hasBankingInfo: false,
      bankDetails: { ...emptyBankDetails },
      hasBankDetails: false,
      bankName: "",
      accountNumber: "",
      currency: "",
    });
    setBankFormErrors({});
    setShowAccountNumber(false);
  };
  const openEditAnnouncement = (a) => {
    console.log("openEditAnnouncement--------",a);
    let formattedExpiryForPicker = "";
    if (a.expiryDate) {
      formattedExpiryForPicker = a.expiryDate.replace(" ", "T").slice(0, 16);
    }
    setEditAnnouncementForm({
      id: a.id,
      title: a.title,
      body: a.body,
      audienceType: a.audienceType,
      targetFundId: a.audienceType === "fund" ? a.targetFundId : "",
      expiryDate: formattedExpiryForPicker,
      status: a.status,
      numberby: a.numberby,
    });
    setEditAnnouncementDialog(true);
  };

  const closeEditAnnouncement = () => {
    setEditAnnouncementDialog(false);
  };

  const formatExpiryDateTime = (dateTimeString) => {
    if (!dateTimeString) return "";
    // If user selected value like "2026-07-17T14:54", convert 'T' to space and append seconds if missing
    let formatted = dateTimeString.replace("T", " ");
    if (formatted.length === 16) {
      formatted += ":00"; // Appends :ss if seconds aren't included by default
    }
    return formatted;
  };

  const handleUpdateAnnouncement = async () => {
    const { id, title, body, audienceType, targetFundId, expiryDate, status, numberby } = editAnnouncementForm;

    console.log("handleUpdateAnnouncement_editAnnouncementForm============",editAnnouncementForm);
    console.log("handleUpdateAnnouncement_numberby============",numberby);
  
    if (!title.trim() || !body.trim()) {
      setSnackbar({ open: true, message: "Title and body are required.", severity: "warning" });
      return;
    }
    if (audienceType === "fund" && !targetFundId) {
      setSnackbar({ open: true, message: "Please select a target fund.", severity: "warning" });
      return;
    }
  
    setIsUpdatingAnnouncement(true);

    const formattedExpiry = formatExpiryDateTime(expiryDate);

    try {
      const response = await PortfolioUpdateAnnouncement(
        "",
        id,
        audienceType === "fund" ? targetFundId : "0",
        title,
        body,
        agentID,
        formattedExpiry,
        status ? 1 : 0, // Appended parameter
        numberby                      // Appended parameter
      );
  
      const callStatus = response?.data?.header?.callStatus;
      if (callStatus === "1" || callStatus === 1) {
        await fetchAnnouncements();
        setEditAnnouncementDialog(false);
        setSnackbar({ open: true, message: response?.data?.header?.msg || "Announcement updated.", severity: "success" });
      } else {
        setSnackbar({ open: true, message: response?.data?.header?.msg || "Failed to update.", severity: "error" });
      }
    } catch (error) {
      console.error("Failed to update announcement:", error);
      setSnackbar({ open: true, message: "Something went wrong.", severity: "error" });
    } finally {
      setIsUpdatingAnnouncement(false);
    }
  };

  const validateForm = () => {
    const {
      firstName,
      lastName,
      email,
      contactNumber,
      countryCode,
      gender,
      role,
      assignedInvestorId,
    } = onboardData;
    if (
      !firstName ||
      !lastName ||
      !email ||
      !contactNumber ||
      !countryCode ||
      !gender ||
      !role
    )
      return false;
    if (role === "delegate" && !assignedInvestorId) return false;
    if (!validateBankDetails()) return false;
    return true;
  };

  // Basic client-side checks for the banking section. This is UI-only for now —
  // there is no backend endpoint wired up yet to persist this data.
  const validateBankDetails = () => {
    if (!onboardData.hasBankDetails) return true;

    const {
      accountHolderName,
      bankName,
      accountNumber,
      confirmAccountNumber,
      routingNumber,
      accountType,
      bankCountry,
    } = onboardData.bankDetails;

    const errors = {};
    if (!accountHolderName?.trim()) errors.accountHolderName = "Required";
    if (!bankName?.trim()) errors.bankName = "Required";
    if (!accountNumber?.trim()) errors.accountNumber = "Required";
    if (!routingNumber?.trim()) errors.routingNumber = "Required";
    if (!accountType) errors.accountType = "Required";
    if (!bankCountry) errors.bankCountry = "Required";
    if (
      accountNumber &&
      confirmAccountNumber &&
      accountNumber !== confirmAccountNumber
    ) {
      errors.confirmAccountNumber = "Account numbers do not match";
    }

    setBankFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleBankDetailsChange = (field, value) => {
    setOnboardData((prev) => ({
      ...prev,
      bankDetails: { ...prev.bankDetails, [field]: value },
    }));
    if (bankFormErrors[field]) {
      setBankFormErrors((prev) => ({ ...prev, [field]: undefined }));
    }
  };

  const toggleHasBankDetails = (checked) => {
    setOnboardData((prev) => ({
      ...prev,
      hasBankDetails: checked,
      bankDetails: checked ? prev.bankDetails : { ...emptyBankDetails },
    }));
    setBankFormErrors({});
  };

  const handleExistingUserDelegate = async (existingUserId) => {
    const targetInvestorId =
      userRole === "admin"
        ? onboardData.assignedInvestorId
        : JSON.parse(sessionStorage.getItem("user"))?.userid || "";

    try {
      const assignResponse = await PortfolioAssignDelegate(
        "",
        targetInvestorId,
        existingUserId,
      );
      if (assignResponse) {
        setSnackbar({
          open: true,
          message: `User assigned successfully as a Delegate.`,
          severity: "success",
        });
        clearFields();
      }
    } catch (error) {
      console.error("Assignment Error:", error);
    } finally {
      setAlert((prev) => ({ ...prev, showAlert: false }));
    }
  };

  const handleOnboardSubmit = async () => {
    if (!validateForm()) {
      setSnackbar({
        open: true,
        message: "Please fill in all required fields.",
        severity: "warning",
      });
      return;
    }

    setIsOnboarding(true);

    const {
      role,
      entities,
      hasEntities,
      assignedInvestorId,
      firstName,
      lastName,
      email,
      countryCode,
      contactNumber,
      gender,
      accountNumber,
      bankName,
      currency,
      hasBankingInfo
    } = onboardData;
    const roleToBeSend = role;

    const filteredEntities = entities.filter((e) => e.trim() !== "");

    console.log("onboardData================", onboardData);
    console.log("Entities to save================", filteredEntities);
    // Banking details are collected in onboardData.bankDetails but are not yet
    // sent anywhere — there is no API for this feature yet (skeleton UI only).
    console.log(
      "Bank details to save (not yet wired to an API)================",
      onboardData.hasBankDetails ? onboardData.bankDetails : null,
    );

    try {
      const response = await createNewPortfolioUser(
        email,
        firstName,
        lastName,
        countryCode,
        contactNumber,
        gender,
        agentID,
        2,
        roleToBeSend,
        filteredEntities,
        hasEntities,
        hasBankingInfo,
        accountNumber,
        bankName,
        currency,
      );

      // Handle "Email already registered" case
      if (response?.payload?.callStatus === "0") {
        const existingUserId = response?.payload?.currentUserID;

        // Only show prompt if current role selection is Delegate
        if (role === "delegate" && existingUserId) {
          setAlert({
            showAlert: true,
            message: `A user with the email id ${email} already exists. Do you want to continue adding this user as a delegate?`,
            severity: "confirm",
            header: "Please Confirm",
            alertType: "confirm",
            onConfirm: () => handleExistingUserDelegate(existingUserId),
          });
        } else {
          setSnackbar({
            open: true,
            message: response.payload.msg || "This email cannot be registered.",
            severity: "error",
          });
        }
        setIsOnboarding(false);
        return;
      }
      console.log("handleOnboardSubmit_role==============", role);
      if (response?.payload?.callStatus === "1") {
        const newUserId = response?.payload?.userid;
        console.log("handleOnboardSubmit_newUserId==============", newUserId);
        if (role === "delegate") {
          const targetInvestorId =
            userRole === "admin"
              ? assignedInvestorId
              : JSON.parse(sessionStorage.getItem("user"))?.userid || "";
          console.log(
            "handleOnboardSubmit_targetInvestorId==============",
            targetInvestorId,
          );
          if (targetInvestorId && newUserId) {
            await PortfolioAssignDelegate("", targetInvestorId, newUserId);
          }
        }

        setSnackbar({
          open: true,
          message: `${firstName} ${lastName} onboarded successfully.`,
          severity: "success",
        });
        clearFields();
      }
    } catch (error) {
      console.log("createNewPortfolioUser_error-----------",error);
      setSnackbar({
        open: true,
        message: "Something went wrong.",
        severity: "error",
      });
    } finally {
      setIsOnboarding(false); // Stop loading safely when done
    }
  };

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };
  //   const handleAnnouncementSubmit = () => {
  //   const { title, body, audienceType, targetFundId } = announcementForm;
  //   if (!title.trim() || !body.trim()) {
  //     setSnackbar({ open: true, message: "Title and body are required.", severity: "warning" });
  //     return;
  //   }
  //   const targetFundName = funds.find((f) => f.id === targetFundId)?.name || "";
  //   setAnnouncements((prev) => [{ id: Date.now(), title, body, audienceType, targetFundName }, ...prev]);
  //   setAnnouncementForm({ title: "", body: "", audienceType: "all", targetFundId: "" });
  //   setSnackbar({ open: true, message: "Announcement published.", severity: "success" });
  // };
  const handleAnnouncementSubmit = async () => {
    const { title, body, audienceType, targetFundId, expiryDate, status } = announcementForm;

    console.log("handleAnnouncementSubmit_announcementForm==========",announcementForm);

    if (!title.trim() || !body.trim()) {
      setSnackbar({ open: true, message: "Title and body are required.", severity: "warning" });
      return;
    }
    if (audienceType === "fund" && !targetFundId) {
      setSnackbar({ open: true, message: "Please select a target fund.", severity: "warning" });
      return;
    }
    setIsPublishingAnnouncement(true);

    const formattedExpiry = formatExpiryDateTime(expiryDate);

    try {
      const response = await PortfolioCreateAnnouncement(
        agentID,
        audienceType === "fund" ? targetFundId : 0,
        title,
        body,
        formattedExpiry,                      // Pass expiry date payload
        status ? 1 : 0 // Pass status payload
      );

      const callStatus = response?.data?.header?.callStatus;
      if (callStatus === "1" || callStatus === 1) {
        await fetchAnnouncements();
        setAnnouncementForm({ title: "", body: "", audienceType: "all", targetFundId: "", expiryDate: "", status: true });
        setSnackbar({ open: true, message: response?.data?.header?.msg || "Announcement published.", severity: "success" });
      } else {
        setSnackbar({ open: true, message: response?.data?.header?.msg || "Failed to publish.", severity: "error" });
      }
    } catch (error) {
      console.error("Failed to create announcement:", error);
      setSnackbar({ open: true, message: "Something went wrong.", severity: "error" });
    } finally {
      setIsPublishingAnnouncement(false);
    }
  };
  const handleDeleteAnnouncement = async (id) => {
    setDeletingAnnouncementId(id);
    try {
      const response = await PortfolioDeleteAnnouncement("", id);
      console.log("PortfolioDeleteAnnouncement response--------", response);

      const callStatus = response?.data?.header?.callStatus;

      if (callStatus === "1" || callStatus === 1) {
        await fetchAnnouncements();
        setSnackbar({
          open: true,
          message: response?.data?.header?.msg || "Announcement deleted.",
          severity: "success",
        });
      } else {
        setSnackbar({
          open: true,
          message:
            response?.data?.header?.msg || "Failed to delete announcement.",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Failed to delete announcement:", error);
      setSnackbar({
        open: true,
        message: "Something went wrong.",
        severity: "error",
      });
    } finally {
      setAlert((prev) => ({ ...prev, showAlert: false }));
      setDeletingAnnouncementId(null);
    }
  };

  const confirmDeleteAnnouncement = (id, title) => {
    setAlert({
      showAlert: true,
      message: `Are you sure you want to delete "${title}"? This cannot be undone.`,
      severity: "confirm",
      header: "Delete Announcement",
      alertType: "confirm",
      onConfirm: () => handleDeleteAnnouncement(id),
    });
  };
  const handleEntityChange = (index, value) => {
    const newEntities = [...onboardData.entities];
    newEntities[index] = value;
    setOnboardData({ ...onboardData, entities: newEntities });
  };

  const addEntityField = () => {
    setOnboardData({ ...onboardData, entities: [...onboardData.entities, ""] });
  };

  const removeEntityField = (index) => {
    const newEntities = onboardData.entities.filter((_, i) => i !== index);
    setOnboardData({
      ...onboardData,
      entities: newEntities.length ? newEntities : [""],
    });
  };

  // --- Native HTML5 Drag and Drop Event Handlers ---
const handleDragStart = (e, index) => {
  setDraggedItemIndex(index);
  e.dataTransfer.effectAllowed = "move";
};

const handleDragOver = (index) => {
  if (draggedItemIndex === null || draggedItemIndex === index) return;
  
  // Update state positions live during drag over
  const updatedAnnouncements = [...announcements];
  const draggedItem = updatedAnnouncements[draggedItemIndex];
  updatedAnnouncements.splice(draggedItemIndex, 1);
  updatedAnnouncements.splice(index, 0, draggedItem);
  
  setDraggedItemIndex(index);
  setAnnouncements(updatedAnnouncements);
};

const handleDragEnd = async () => {
  if (draggedItemIndex === null) return;
  
  const targetAnnouncement = announcements[draggedItemIndex];
  console.log("targetAnnouncement=======",targetAnnouncement);
  setDraggedItemIndex(null);
  
  // Triggers API call on drag release position drop
  // try {
  //   setSnackbar({ open: true, message: "Updating announcement position...", severity: "info" });
  //   await PortfolioUpdateAnnouncement(
  //     "", 
  //     targetAnnouncement.id,
  //     targetAnnouncement.audienceType === "fund" ? targetAnnouncement.targetFundId : "0",
  //     targetAnnouncement.title,
  //     targetAnnouncement.body,
  //     agentID,
  //     targetAnnouncement.status ? "active" : "inactive",
  //     targetAnnouncement.expiryDate
  //   );
  //   setSnackbar({ open: true, message: "Announcement order saved successfully.", severity: "success" });
  // } catch (error) {
  //   console.error("Failed to update ordering on drop:", error);
  //   setSnackbar({ open: true, message: "Failed to save row changes.", severity: "error" });
  // }
};

  console.log("onboardData------------", onboardData);
  console.log("userRole------------", userRole);

  return (
    <Box className="admin-container">
      <Box className="header-card">
        <Box>
          <Box display="flex" alignItems="center" gap={1}>
            <Typography variant="h5" fontWeight="bold">
              THE HOLT XCHANGE
            </Typography>
            <Typography
              variant="h6"
              sx={{ ml: 2, borderLeft: "1px solid #ccc", pl: 2 }}
            >
              Admin Console
            </Typography>
          </Box>
          <Typography variant="body2" color="textSecondary">
            Manage users, uploads, investor profiles, and permissions
          </Typography>
        </Box>
        <Button
          variant="outlined"
          onClick={onExit}
          sx={{ textTransform: "none", color: "#000", borderColor: "#000" }}
        >
          Exit Admin
        </Button>
      </Box>
      <Tabs
        value={adminTab}
        onChange={(e, v) => setAdminTab(v)}
        sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
      >
        <Tab
          icon={<PersonAddIcon fontSize="small" />}
          iconPosition="start"
          label="Onboard User"
          sx={{ textTransform: "none" }}
        />
        {userRole == "admin" && <Tab
          icon={<CampaignIcon fontSize="small" />}
          iconPosition="start"
          label="Announcements"
          sx={{ textTransform: "none" }}
        />}
      </Tabs>
      {adminTab === 0 && (
        <Box className="dashboard-card" sx={{ mb: 3 }}>
          <Typography variant="h6" fontWeight="bold">
            Onboard New User
          </Typography>
          <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
            Enter the details below to create a new user profile.
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="First Name"
                name="firstName"
                size="small"
                required
                value={onboardData.firstName}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Last Name"
                name="lastName"
                size="small"
                required
                value={onboardData.lastName}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Email Address"
                name="email"
                type="email"
                size="small"
                required
                value={onboardData.email}
                onChange={handleInputChange}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Contact Number"
                name="contactNumber"
                size="small"
                required
                value={onboardData.contactNumber}
                onChange={handleInputChange}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <Autocomplete
                options={countries.filter((c) => c.id !== "novalue")}
                getOptionLabel={(option) =>
                  `${option.country} (${option.areaCode})`
                }
                value={
                  countries.find((c) => c.flag === onboardData.countryCode) ||
                  null
                }
                onChange={(event, newValue) => {
                  setOnboardData((prev) => ({
                    ...prev,
                    areaCode: newValue ? newValue.areaCode : "",
                    countryCode: newValue ? newValue.flag : "",
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Country Code"
                    size="small"
                    required
                  />
                )}
              />
            </Grid>

            <Grid item xs={12} md={4}>
              <FormControl fullWidth size="small" required>
                <InputLabel>Gender</InputLabel>
                <Select
                  name="gender"
                  value={onboardData.gender}
                  onChange={handleInputChange}
                  label="Gender"
                >
                  <MenuItem value="1">Male</MenuItem>
                  <MenuItem value="2">Female</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {userRole === "admin" && (
              <>
                <Grid item xs={12} md={4}>
                  <FormControl fullWidth size="small" required>
                    <InputLabel>Role</InputLabel>
                    <Select
                      name="role"
                      value={onboardData.role}
                      onChange={handleInputChange}
                      label="Role"
                    >
                      <MenuItem value="investor">Investor</MenuItem>
                      <MenuItem value="delegate">Delegate</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                {onboardData.role == "delegate" && userRole == "admin" && (
                  <Grid item xs={12} md={6}>
                    <FormControl fullWidth size="small" required>
                      <InputLabel>Assign to Investor</InputLabel>
                      <Select
                        name="assignedInvestorId"
                        value={onboardData.assignedInvestorId}
                        onChange={handleInputChange}
                        label="Assign to Investor"
                      >
                        {investors.map((inv) => (
                          <MenuItem key={inv.id} value={inv.id}>
                            {inv.name} ({inv.email})
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
              </>
            )}

            {/* Logic for Admin + Investor Role */}
            {onboardData.role === "investor" && (
              <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={onboardData.hasEntities}
                      onChange={(e) =>
                        setOnboardData({
                          ...onboardData,
                          hasEntities: e.target.checked,
                        })
                      }
                      color="primary"
                    />
                  }
                  label="Does this investor have associated entities?"
                />

                {onboardData.hasEntities && (
                  <Box
                    sx={{
                      mt: 2,
                      p: 2,
                      border: "1px dashed #ccc",
                      borderRadius: 1,
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                      Add Entities
                    </Typography>
                    {onboardData.entities.map((entity, index) => (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mb: 1,
                          gap: 1,
                        }}
                      >
                        <TextField
                          fullWidth
                          size="small"
                          label={`Entity Name ${index + 1}`}
                          value={entity}
                          onChange={(e) =>
                            handleEntityChange(index, e.target.value)
                          }
                        />
                        <IconButton onClick={addEntityField} color="primary">
                          <AddCircleOutlineIcon />
                        </IconButton>
                        {onboardData.entities.length > 1 && (
                          <IconButton
                            onClick={() => removeEntityField(index)}
                            color="error"
                          >
                            <RemoveCircleOutlineIcon />
                          </IconButton>
                        )}
                      </Box>
                    ))}
                  </Box>
                )}

                {/* Banking Details */}
                <FormControlLabel
                  control={
                    <Switch
                      checked={onboardData.hasBankingInfo}
                      onChange={(e) =>
                        setOnboardData({
                          ...onboardData,
                          hasBankingInfo: e.target.checked,
                        })
                      }
                      color="primary"
                    />
                  }
                  label="Collect user's banking related details?"
                />

                {onboardData.hasBankingInfo && (
                  <Box
                    sx={{
                      mt: 2,
                      p: 2,
                      border: "1px dashed #ccc",
                      borderRadius: 1,
                    }}
                  >
                    <Typography variant="subtitle2" sx={{ mb: 2 }}>
                      Banking Information
                    </Typography>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={4}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Bank Name"
                          name="bankName"
                          value={onboardData.bankName}
                          onChange={handleInputChange}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Account Number"
                          name="accountNumber"
                          value={onboardData.accountNumber}
                          onChange={handleInputChange}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <TextField
                          fullWidth
                          size="small"
                          label="Currency"
                          name="currency"
                          value={onboardData.currency}
                          onChange={handleInputChange}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </Grid>
            )}

            {/* Banking Information Capture — skeleton UI only, not yet wired to an API */}
            {/* <Grid item xs={12}>
              <Divider sx={{ my: 1 }} />
              <FormControlLabel
                control={
                  <Switch
                    checked={onboardData.hasBankDetails}
                    onChange={(e) => toggleHasBankDetails(e.target.checked)}
                    color="primary"
                  />
                }
                label="Do you have this person's banking details to add?"
              />

              {onboardData.hasBankDetails && (
                <Box
                  sx={{
                    mt: 2,
                    p: 2.5,
                    border: "1px solid #e0e0e0",
                    borderRadius: 1.5,
                    bgcolor: "#fafafa",
                  }}
                >
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{ mb: 0.5 }}
                  >
                    <AccountBalanceIcon
                      fontSize="small"
                      sx={{ color: "#001529" }}
                    />
                    <Typography variant="subtitle2" fontWeight="bold">
                      Banking Information
                    </Typography>
                  </Box>
                  <Box
                    display="flex"
                    alignItems="center"
                    gap={0.5}
                    sx={{ mb: 2 }}
                  >
                    <LockOutlinedIcon
                      sx={{ fontSize: 14, color: "text.secondary" }}
                    />
                    <Typography variant="caption" color="textSecondary">
                      Used only to process transactions for this account. Stored
                      securely and never shared.
                    </Typography>
                  </Box>

                  <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Account Holder Name"
                        required
                        value={onboardData.bankDetails.accountHolderName}
                        onChange={(e) =>
                          handleBankDetailsChange(
                            "accountHolderName",
                            e.target.value,
                          )
                        }
                        error={!!bankFormErrors.accountHolderName}
                        helperText={bankFormErrors.accountHolderName}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Bank Name"
                        required
                        value={onboardData.bankDetails.bankName}
                        onChange={(e) =>
                          handleBankDetailsChange("bankName", e.target.value)
                        }
                        error={!!bankFormErrors.bankName}
                        helperText={bankFormErrors.bankName}
                      />
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Account Number"
                        required
                        type={showAccountNumber ? "text" : "password"}
                        value={onboardData.bankDetails.accountNumber}
                        onChange={(e) =>
                          handleBankDetailsChange(
                            "accountNumber",
                            e.target.value,
                          )
                        }
                        error={!!bankFormErrors.accountNumber}
                        helperText={bankFormErrors.accountNumber}
                        InputProps={{
                          endAdornment: (
                            <IconButton
                              size="small"
                              onClick={() =>
                                setShowAccountNumber((prev) => !prev)
                              }
                              edge="end"
                              tabIndex={-1}
                            >
                              {showAccountNumber ? (
                                <VisibilityOffIcon fontSize="small" />
                              ) : (
                                <VisibilityIcon fontSize="small" />
                              )}
                            </IconButton>
                          ),
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Confirm Account Number"
                        required
                        type={showAccountNumber ? "text" : "password"}
                        value={onboardData.bankDetails.confirmAccountNumber}
                        onChange={(e) =>
                          handleBankDetailsChange(
                            "confirmAccountNumber",
                            e.target.value,
                          )
                        }
                        error={!!bankFormErrors.confirmAccountNumber}
                        helperText={bankFormErrors.confirmAccountNumber}
                      />
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <TextField
                        fullWidth
                        size="small"
                        label="Routing / SWIFT / IFSC Code"
                        required
                        value={onboardData.bankDetails.routingNumber}
                        onChange={(e) =>
                          handleBankDetailsChange(
                            "routingNumber",
                            e.target.value,
                          )
                        }
                        error={!!bankFormErrors.routingNumber}
                        helperText={bankFormErrors.routingNumber}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <FormControl
                        fullWidth
                        size="small"
                        required
                        error={!!bankFormErrors.accountType}
                      >
                        <InputLabel>Account Type</InputLabel>
                        <Select
                          label="Account Type"
                          value={onboardData.bankDetails.accountType}
                          onChange={(e) =>
                            handleBankDetailsChange(
                              "accountType",
                              e.target.value,
                            )
                          }
                        >
                          {BANK_ACCOUNT_TYPES.map((opt) => (
                            <MenuItem key={opt.value} value={opt.value}>
                              {opt.label}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Autocomplete
                        options={countries.filter((c) => c.id !== "novalue")}
                        getOptionLabel={(option) => option.country}
                        value={
                          countries.find(
                            (c) =>
                              c.country === onboardData.bankDetails.bankCountry,
                          ) || null
                        }
                        onChange={(event, newValue) =>
                          handleBankDetailsChange(
                            "bankCountry",
                            newValue ? newValue.country : "",
                          )
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Bank Country"
                            size="small"
                            required
                            error={!!bankFormErrors.bankCountry}
                            helperText={bankFormErrors.bankCountry}
                          />
                        )}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Grid> */}

            <Grid item xs={12}>
              <Divider sx={{ my: 1, borderStyle: "dashed" }} />
              <Button
                variant="contained"
                onClick={handleOnboardSubmit}
                sx={{ bgcolor: "#001529", textTransform: "none", mt: 1, px: 4 }}
              >
                {isOnboarding ? "Onboarding..." : "Complete Onboarding"}
              </Button>
            </Grid>
          </Grid>
        </Box>
      )}

      {adminTab === 1 && (
        <AdminAnnouncements
          funds={funds}
          setSnackbar={setSnackbar}
          setAlert={setAlert}
          agentID={agentID}
        />
      )}

      <Dialog
        open={editAnnouncementDialog}
        onClose={closeEditAnnouncement}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Edit Announcement</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Title"
                value={editAnnouncementForm.title}
                onChange={(e) =>
                  setEditAnnouncementForm((p) => ({
                    ...p,
                    title: e.target.value,
                  }))
                }
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Body"
                multiline
                minRows={3}
                value={editAnnouncementForm.body}
                onChange={(e) =>
                  setEditAnnouncementForm((p) => ({
                    ...p,
                    body: e.target.value,
                  }))
                }
              />
            </Grid>
            <Grid item xs={12} md={5}>
              <FormControl fullWidth size="small">
                <InputLabel>Audience</InputLabel>
                <Select
                  label="Audience"
                  value={editAnnouncementForm.audienceType}
                  onChange={(e) =>
                    setEditAnnouncementForm((p) => ({
                      ...p,
                      audienceType: e.target.value,
                      targetFundId: "",
                    }))
                  }
                >
                  <MenuItem value="all">All Investors</MenuItem>
                  <MenuItem value="fund">Specific Fund</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {editAnnouncementForm.audienceType === "fund" && (
              <Grid item xs={12} md={7}>
                <FormControl fullWidth size="small">
                  <InputLabel>Target Fund</InputLabel>
                  <Select
                    label="Target Fund"
                    value={editAnnouncementForm.targetFundId}
                    onChange={(e) =>
                      setEditAnnouncementForm((p) => ({
                        ...p,
                        targetFundId: e.target.value,
                      }))
                    }
                  >
                    {funds.map((f) => (
                      <MenuItem key={f.id} value={f.id}>
                        {f.name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            )}

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                size="small"
                label="Expiry Date & Time"
                type="datetime-local"
                InputLabelProps={{ shrink: true }}
                value={editAnnouncementForm.expiryDate}
                onChange={(e) =>
                  setEditAnnouncementForm((p) => ({ ...p, expiryDate: e.target.value }))
                }
              />
            </Grid>

            <Grid item xs={12} md={6} display="flex" alignItems="center">
              <FormControlLabel control={<Switch checked={editAnnouncementForm.status} onChange={(e) => setEditAnnouncementForm((p) => ({ ...p, status: e.target.checked }))} color="primary" />} label={editAnnouncementForm.status ? "Active" : "Inactive"} />
            </Grid>

          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeEditAnnouncement}
            sx={{ textTransform: "none" }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={handleUpdateAnnouncement}
            disabled={isUpdatingAnnouncement}
            startIcon={
              isUpdatingAnnouncement ? (
                <CircularProgress size={16} color="inherit" />
              ) : null
            }
            sx={{ bgcolor: "#001529", textTransform: "none" }}
          >
            {isUpdatingAnnouncement ? "Saving..." : "Save Changes"}
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>

      <CustomAlert
        severity={alert.severity}
        show={alert.showAlert}
        header={alert.header}
        message={alert.message}
        onClick={(prevDetails) => {
          setAlert({ ...prevDetails, showAlert: false });
        }}
        alertType={alert.alertType}
        confirmButton={alert.onConfirm}
        autoclose={alert.severity === "error" ? false : true}
      />
    </Box>
  );
};

export default AdminConsole;
